export default function WhenInContainer (props) {
  return props?.container
    ? <div className={`container${props?.className ? ` ${props.className}` : ''}`}>{props.children}</div>
    : <>{props.children}</>;
}
